import type { COMMUNITY_STATUS } from '@/views/ISPInstall/pages/step/enums/CommunityStatus.enum'
import type { LocationType } from './location'

export interface GetCommunitiesResponse {
  Communities: CommunityItem[]
}

export interface CommunityItem {
  Location: LocationType
  CommunitySn: string
  CommunityName: string
  CommunityStatus: COMMUNITY_STATUS
  City: string
  District: string
  /** 後端部分社區可能未帶路名，故允許 null */
  Road: string | null
  Bandwidth: string
}

export class GetCommunitiesRequest {
  City: string
  FuzzyCommunityName: string
  /** 行政區（帶此值 + 空 FuzzyCommunityName 可列出該行政區所有社區；諮詢下拉式搜尋亦使用）*/
  District: string
  constructor() {
    this.City = ''
    this.FuzzyCommunityName = ''
    this.District = ''
  }
}